import HelpingJuniorsComponent from 'components/marketingSite/helpingJuniors/HelpingJuniorsComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/dist/client/router';
import { useEffect, useState } from 'react';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type HelpingJuniorsPageProps = {
  baseUrl?: string;
};

const parseJSON = (resp: any) => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any) => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const HiringProcessComparisonPage: React.FC<HelpingJuniorsPageProps> = ({
  baseUrl
}) => {
  const { t } = useI18n('helping-juniors');

  usePageTrack('Landing - Page Loaded');

  const { locale } = useRouter();

  const [helpingJuniors, setHelpingJuniors] = useState([]);
  const [helpingJuniorsLinks, setHelpingJuniorsLinks] = useState([]);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/helping-junior-sections?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setHelpingJuniors(data));
  }, []);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/helping-junior-section-links?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setHelpingJuniorsLinks(data));
  }, []);

  return (
    <>
      <HeadMetadata
        indexable
        title={t('helping-juniors.page_title')}
        url={APP_URLS.helpingJuniors}
        desc={t('helping-juniors.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_helping_juniors.png'
        )}`}
      />
      <HelpingJuniorsComponent
        content={helpingJuniors}
        links={helpingJuniorsLinks}
      />
    </>
  );
};

export default HiringProcessComparisonPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'helping-juniors'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
